import { City } from "../types/entities/city"
import { Cinema } from "../types/entities/cinema"
import { clearAuthDraft } from "./authDraft"
import { appStore } from "../store/appStore"
import { userStore } from "../store/userStore"

/** city_id для auth-запросов — всегда текущий выбранный город */
export function getAuthCityId(): number {
    return appStore.getState().city.id
}

export function applyPendingLocation(): boolean {
    const { pendingCity, pendingCinema, setLocation, clearPendingLocation } = appStore.getState()
    if (!pendingCity || !pendingCinema) return false
    setLocation({ city: pendingCity, cinema: pendingCinema })
    clearPendingLocation()
    return true
}

/** Сброс pending/reauth-состояния, чтобы старый город не попал в auth-запросы */
export function resetLocationAuthState(): void {
    appStore.getState().clearPendingLocation()
    clearAuthDraft()
}

/** Пользователь авторизован и переходит в другой город */
export function isCityChange(currentCityId: number, nextCityId: number): boolean {
    const { user } = userStore.getState()
    return Boolean(user && currentCityId !== nextCityId)
}

type SelectCinemaOptions = {
    city: City
    cinema: Cinema
    onApplied?: () => void
}

export function selectCinemaLocation({ city: newCity, cinema: selectedCinema, onApplied }: SelectCinemaOptions): void {
    if (selectedCinema.city_id !== newCity.id) {
        console.warn("Cinema does not belong to selected city")
        return
    }

    const { city, setLocation } = appStore.getState()

    resetLocationAuthState()

    if (isCityChange(city.id, newCity.id)) {
        userStore.getState().clearAuth()
    }

    setLocation({ city: newCity, cinema: selectedCinema })
    onApplied?.()
}
